enum SubmitFormEvents {
  /**
   * Dispatched when the a `SubmitForm` object was successfully submitted.
   * 
   * Callback params:
   * 
   * `data`: `ISubmitFormData`. The form data submitted.
   * 
   * `form`: `SubmitForm`. The target form.
   */
  COMPLETE = 'complete',
}

export default SubmitFormEvents;
